export default "__VITE_ASSET__MvsJG0oZla2r3Jy0lMHQOw__"